type StyleConfig = {
	id: string;
	property: string;
	field: any;
	selector: string;
	label: string;
	defaultValue?: string;
	category: { id: string; label?: string };
};

const listTypes = [
	{ id: 'disc', label: 'Disc' },
	{ id: 'circle', label: 'Circle' },
	{ id: 'square', label: 'Square' },
	{ id: 'decimal', label: 'Decimal' },
	{ id: 'cjk-decimal', label: 'Cjk decimal' },
	{ id: 'decimal-leading-zero', label: 'Decimal leading zero' },
	{ id: 'lower-roman', label: 'Lower roman' },
	{ id: 'upper-roman', label: 'Upper roman' },
	{ id: 'lower-greek', label: 'Lower greek' },
	{ id: 'lower-alpha', label: 'Lower alpha' },
	{ id: 'lower-latin', label: 'Lower latin' },
	{ id: 'upper-alpha', label: 'Upper alpha' },
	{ id: 'upper-latin', label: 'Upper latin' },
	{ id: 'arabic-indic', label: 'Arabic indic' },
	{ id: 'armenian', label: 'Armenian' },
	{ id: 'bengali', label: 'Bengali' },
	{ id: 'cambodian', label: 'Cambodian' },
	{ id: 'cjk-earthly-branch', label: 'Cjk earthly branch' },
	{ id: 'cjk-heavenly-stem', label: 'Cjk heavenly stem' },
	{ id: 'cjk-ideographic', label: 'Cjk ideographic' },
	{ id: 'devanagari', label: 'Devanagari' },
	{ id: 'ethiopic-numeric', label: 'Ethiopic numeric' },
	{ id: 'georgian', label: 'Georgian' },
	{ id: 'gujarati', label: 'Gujarati' },
	{ id: 'gurmukhi', label: 'Gurmukhi' },
	{ id: 'hebrew', label: 'Hebrew' },
	{ id: 'hiragana', label: 'Hiragana' },
	{ id: 'hiragana-iroha', label: 'Hiragana iroha' },
	{ id: 'japanese-formal', label: 'Japanese formal' },
	{ id: 'japanese-informal', label: 'Japanese informal' },
	{ id: 'kannada', label: 'Kannada' },
	{ id: 'katakana', label: 'Katakana' },
	{ id: 'katakana-iroha', label: 'Katakana iroha' },
	{ id: 'khmer', label: 'Khmer' },
	{ id: 'korean-hangul-formal', label: 'Korean hangul formal' },
	{ id: 'korean-hanja-formal', label: 'Korean hanja formal' },
	{ id: 'korean-hanja-informal', label: 'Korean hanja informal' },
	{ id: 'lao', label: 'Lao' },
	{ id: 'lower-armenian', label: 'Lower armenian' },
	{ id: 'malayalam', label: 'Malayalam' },
	{ id: 'mongolian', label: 'Mongolian' },
	{ id: 'myanmar', label: 'Myanmar' },
	{ id: 'oriya', label: 'Oriya' },
	{ id: 'persian', label: 'Persian' },
	{ id: 'simp-chinese-formal', label: 'Simp chinese formal' },
	{ id: 'simp-chinese-informal', label: 'Simp chinese informal' },
	{ id: 'tamil', label: 'Tamil' },
	{ id: 'telugu', label: 'Telugu' },
	{ id: 'thai', label: 'Thai' },
	{ id: 'tibetan', label: 'Tibetan' },
	{ id: 'trad-chinese-formal', label: 'Trad chinese formal' },
	{ id: 'trad-chinese-informal', label: 'Trad chinese informal' },
	{ id: 'upper-armenian', label: 'Upper armenian' },
	{ id: 'disclosure-open', label: 'Disclosure open' },
	{ id: 'disclosure-closed', label: 'Disclosure closed' },
	{ id: '-moz-ethiopic-halehame', label: 'Moz ethiopic halehame' },
	{ id: '-moz-ethiopic-halehame-am', label: 'Moz ethiopic halehame am' },
	{ id: 'ethiopic-halehame-ti-er', label: 'Ethiopic halehame ti er' },
	{ id: 'ethiopic-halehame-ti-et', label: 'Ethiopic halehame ti et' },
	{ id: 'hangul', label: 'Hangul' },
	{ id: 'hangul-consonant', label: 'Hangul consonant' },
	{ id: 'urdu', label: 'Urdu' },
	{ id: '-moz-ethiopic-halehame-ti-er', label: 'Moz ethiopic halehame ti er' },
	{ id: '-moz-ethiopic-halehame-ti-et', label: 'Moz ethiopic halehame ti et' },
	{ id: '-moz-hangul', label: 'Moz hangul' },
	{ id: '-moz-hangul-consonant', label: 'Moz hangul consonant' },
	{ id: '-moz-urdu', label: 'Moz urdu' },
];

const bodyGlobalStyles: StyleConfig[] = [
	{
		id: 'bodyBg',
		property: 'background-color',
		field: 'color',
		selector: 'body',
		label: 'Body background',
		defaultValue: '',
		category: { id: 'body', label: 'Body styles' },
	},
	{
		id: 'bodyColor',
		property: 'color',
		field: 'color',
		selector: 'body',
		label: 'Body color',
		defaultValue: '',
		category: { id: 'body' },
	},
	{
		id: 'bodyPadding',
		property: 'padding',
		field: { type: 'number', min: 0, max: 10, step: 0.1, units: ['rem'] },
		selector: 'body',
		defaultValue: '',
		label: 'Body padding',
		category: { id: 'body' },
	},
];

const buttonGlobalStyles: StyleConfig[] = [
	// btn primary
	{
		id: 'btnColorPrimary',
		property: 'background-color',
		field: 'color',
		selector: '.btn-primary',
		label: 'button color',
		category: { id: 'btnPrimary', label: 'btn-primary' },
	},
	{
		id: 'btnRadiusPrimary',
		property: 'border-radius',
		field: { type: 'number', min: 0, max: 10, step: 0.1, units: ['rem'] },
		selector: '.btn-primary',
		label: 'button radius',
		category: { id: 'btnPrimary' },
	},
	{
		id: 'btnPaddingPrimary',
		property: 'padding',
		field: { type: 'number', min: 0, max: 10, step: 0.1, units: ['rem'] },
		selector: '.btn-primary',
		label: 'button padding',
		category: { id: 'btnPrimary' },
	},
	{
		id: 'btnFontSizePrimary',
		property: 'font-size',
		field: { type: 'number', min: 8, max: 92, step: 1, units: ['px'] },
		selector: '.btn-primary',
		label: 'button font-size',
		category: { id: 'btnPrimary' },
	},
	{
		id: 'btnWidthPrimary',
		property: 'width',
		field: { type: 'number', min: 1, max: 1000, step: 1, units: ['px'] },
		selector: '.btn-primary',
		label: 'button width',
		category: { id: 'btnPrimary' },
	},
	{
		id: 'btnHeightPrimary',
		property: 'height',
		field: { type: 'number', min: 1, max: 1000, step: 1, units: ['px'] },
		selector: '.btn-primary',
		label: 'button height',
		category: { id: 'btnPrimary' },
	},
	// btn secondary
	{
		id: 'btnColorSecondary',
		property: 'background-color',
		field: 'color',
		selector: '.btn-secondary',
		label: 'button color',
		category: { id: 'btnSecondary', label: 'btn-secondary' },
	},
	{
		id: 'btnRadiusSecondary',
		property: 'border-radius',
		field: { type: 'number', min: 0, max: 10, step: 0.1, units: ['rem'] },
		selector: '.btn-secondary',
		label: 'button radius',
		category: { id: 'btnSecondary' },
	},
	{
		id: 'btnPaddingSecondary',
		property: 'padding',
		field: { type: 'number', min: 0, max: 10, step: 0.1, units: ['rem'] },
		selector: '.btn-secondary',
		label: 'button padding',
		category: { id: 'btnSecondary' },
	},
	{
		id: 'btnFontSizeSecondary',
		property: 'font-size',
		field: { type: 'number', min: 8, max: 92, step: 1, units: ['px'] },
		selector: '.btn-secondary',
		label: 'button font-size',
		category: { id: 'btnSecondary' },
	},
	{
		id: 'btnWidthSecondary',
		property: 'width',
		field: { type: 'number', min: 1, max: 1000, step: 1, units: ['px'] },
		selector: '.btn-secondary',
		label: 'button width',
		category: { id: 'btnSecondary' },
	},
	{
		id: 'btnHeightSecondary',
		property: 'height',
		field: { type: 'number', min: 1, max: 1000, step: 1, units: ['px'] },
		selector: '.btn-secondary',
		label: 'button height',
		category: { id: 'btnSecondary' },
	},
];

const h1Config: StyleConfig[] = [
	{
		id: 'h1Color',
		property: 'color',
		field: 'color',
		selector: 'h1',
		label: 'H1 color',
		defaultValue: 'inherit',
		category: { id: 'h1', label: 'H1' },
	},
	{
		id: 'h1Size',
		property: 'font-size',
		field: { type: 'number', min: 0.1, max: 10, step: 0.1, units: ['rem'] },
		defaultValue: '2rem',
		selector: 'h1',
		label: 'H1 size',
		category: { id: 'h1' },
	},
	{
		id: 'h1Padding',
		property: 'padding',
		field: { type: 'number', min: 0, max: 10, step: 0.1, units: ['rem'] },
		defaultValue: '0rem',
		selector: 'h1',
		label: 'H1 padding',
		category: { id: 'h1' },
	},
	{
		id: 'h1Margin',
		property: 'margin',
		field: { type: 'number', min: 0, max: 10, step: 0.1, units: ['rem'] },
		defaultValue: '0rem',
		selector: 'h1',
		label: 'H1 margin',
		category: { id: 'h1' },
	},
	{
		id: 'h1LineHeight',
		property: 'line-height',
		field: { type: 'number', min: 0, max: 100, step: 0.1, units: ['px'] },
		defaultValue: 'normal',
		selector: 'h1',
		label: 'H1 line height',
		category: { id: 'h1' },
	},
	{
		id: 'h1FontStyle',
		property: 'font-style',
		field: {
			type: 'select',
			options: [
				{ id: 'normal', label: 'Normal' },
				{ id: 'italic', label: 'Italic' },
				{ id: 'oblique', label: 'Oblique' },
				{ id: 'italic', label: 'Italic' },
			],
		},
		defaultValue: 'normal',
		selector: 'h1',
		label: 'H1 font style',
		category: { id: 'h1' },
	},
	{
		id: 'h1fontWeight',
		property: 'font-weight',
		field: {
			type: 'select',
			options: [
				{ id: 'normal', label: 'Normal' },
				{ id: 'bold', label: 'Bold' },
				{ id: 'lighter', label: 'Lighter' },
				{ id: 'bolder', label: 'Bolder' },
			],
		},
		defaultValue: 'normal',
		selector: 'h1',
		label: 'H1 font weight',
		category: { id: 'h1' },
	},
	{
		id: 'h1TextDecoration',
		property: 'text-decoration',
		field: {
			type: 'select',
			options: [
				{ id: 'none', label: 'None' },
				{ id: 'underline', label: 'Underline' },
				{ id: 'overline', label: 'Overline' },
				{ id: 'line-through', label: 'Line-Through' },
				{ id: 'blink', label: 'Blink' },
			],
		},
		defaultValue: 'none',
		selector: 'h1',
		label: 'H1 text decoration',
		category: { id: 'h1' },
	},
	{
		id: 'h1TextTransform',
		property: 'text-transform',
		field: {
			type: 'select',
			options: [
				{ id: 'none', label: 'None' },
				{ id: 'uppercase', label: 'Uppercase' },
				{ id: 'lowercase', label: 'LowerCase' },
			],
		},
		defaultValue: 'none',
		selector: 'h1',
		label: 'H1 text transform',
		category: { id: 'h1' },
	},
	{
		id: 'h1TextAlign',
		property: 'text-align',
		field: {
			type: 'select',
			options: [
				{ id: 'center', label: 'Center' },
				{ id: 'end', label: 'End' },
				{ id: 'start', label: 'Start' },
				{ id: 'justify', label: 'Justify' },
			],
		},
		defaultValue: 'start',
		selector: 'h1',
		label: 'H1 text align',
		category: { id: 'h1' },
	},
];

const imgStyles = [
	{
		id: 'imgBorderRadius',
		property: 'border-radius',
		field: { type: 'number', min: 0, max: 100, step: 0.1, units: ['px'] },
		selector: 'img',
		label: 'Border radius',
		defaultValue: '0px',
		category: { id: 'imgStyles', label: 'Img style' },
	},
	{
		id: 'imgWidth',
		property: 'width',
		field: { type: 'number', min: 0, max: 2000, step: 1, units: ['px'] },
		selector: 'img',
		label: 'Width',
		defaultValue: '',
		category: { id: 'imgStyles', label: 'Img width' },
	},
	{
		id: 'imgHeight',
		property: 'height',
		field: { type: 'number', min: 0, max: 2000, step: 1, units: ['px'] },
		selector: 'img',
		label: 'Height',
		defaultValue: '',
		category: { id: 'imgStyles', label: 'Img height' },
	},
];
const generateTagConfig = (tag: 'h2' | 'h3' | 'h4' | 'h5' | 'h6') => {
	return h1Config.map((item) => {
		const newId = item.id.replace('h1', tag);
		const newLabel = item.label.replace(/H1/i, tag.toUpperCase());
		return {
			...item,
			id: newId,
			label: newLabel,
			selector: tag,
			category: { id: tag, label: tag.toUpperCase() },
		};
	});
};
const h2Config = generateTagConfig('h2');
const h3Config = generateTagConfig('h3');
const h4Config = generateTagConfig('h4');
const h5Config = generateTagConfig('h5');
const h6Config = generateTagConfig('h6');

const allHeadingConfigs = [...h1Config, ...h2Config, ...h3Config, ...h4Config, ...h5Config, ...h6Config];

export const defaultGlobalStyles = [
	// CSS variables
	{
		id: 'varPrimary',
		property: '--primary', // connect to a CSS variable
		field: 'color',
		selector: ':root',
		label: '--primary',
		defaultValue: '#0d6efd',
		category: { id: 'vars', label: 'Variables', open: true },
	},
	{
		id: 'varSecondary',
		property: '--secondary',
		field: 'color',
		selector: ':root',
		label: '--secondary',
		defaultValue: '#fd688f',
		category: { id: 'vars' },
	},
	// Img
	...imgStyles,
	// List
	{
		id: 'listStyle',
		property: 'list-style-type',
		field: {
			type: 'select',
			options: listTypes,
		},
		selector: 'ul',
		label: 'List style',
		defaultValue: 'disc',
		category: { id: 'listStyle', label: 'List Style' },
	},
	// Body
	...bodyGlobalStyles,
	// Heading
	...allHeadingConfigs,
	// Buttons
	...buttonGlobalStyles,
];

export const defaultProject = `<!doctype html>
              <html>
                <head>
                  <meta name="viewport" content="width=device-width, initial-scale=1">
                </head>
                <body>
                  <style>
                    .bg-secondary {
                      background-color: var(--secondary) !important;
                    }
                    .btn-primary {
                      --bs-btn-bg: var(--primary);
                    }
                    .btn-primary-soft {
                      --bs-btn-bg: color-mix(in srgb, var(--primary), transparent 90%);
                      --bs-btn-color: var(--primary);
                    }

                    .btn-secondary {
                      --bs-btn-bg: var(--primary);
                    }
                  </style>
<h1>heading</h1>
                </body>
              </html>
            `;
